import script from "./side-menu-inner-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-menu-inner-item.vue?vue&type=script&setup=true&lang=ts"

import "./side-menu-inner-item.vue?vue&type=style&index=0&id=47d7d7ed&lang=scss"

const __exports__ = script;

export default __exports__